<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Edit Package</h3>
        <form name="form1" @submit.prevent="save()">
          <table>
            <tr>
              <td>
                Sport:
              </td>
              <td>
                <select v-model="sport">
                  <option v-for="s in sports" :key="s.id" :value="s">
                    {{ s.sport }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td>
                Name:
              </td>
              <td>
                <input
                  v-model="pack.name"
                  type="text"
                  name="name"
                  size="33"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Current Price:
              </td>
              <td>
                <input
                  v-model="pack.current_price"
                  type="text"
                  name="current_price"
                  size="10"
                  maxlength="100"
                />
              </td>
            </tr>
            <tr>
              <td>
                Sale:
              </td>
              <td>
                <input v-model="pack.sale" type="text" name="sale" />
              </td>
            </tr>
            <tr>
              <td>
                Previous Price:
              </td>
              <td>
                <input
                  v-model="pack.previous_price"
                  type="text"
                  name="previous_price"
                />
              </td>
            </tr>
          </table>
          <p>
            <input type="submit" name="submit" value="Save" />
          </p>
        </form>
        <!-- main-colum END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import PackageRepository from "../../data/package.repository.js";
import _ from "lodash";
export default {
  data() {
    return {
      sports: this.$store.state.sports,
      sport: {},
      pack: {},
    };
  },
  created() {
    if (this.$route.params.id) {
      this.pack = this.$store.getters.package(this.$route.params.id);
      this.sport = _.find(this.sports, ["id", this.pack.sports_id]);
    }
  },
  methods: {
    save() {
      PackageRepository.save(this.pack)
        .then((result) => {
          this.$root.$refs.toastr.s("Result saved");
          this.$router.push("/admin");
        })
        .catch(() => this.$root.$refs.toastr.e("An error occurred"));
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// EditPackage.vue?a24bf08a